<template>
  <v-main>
    <!-- v-main Important to display full map view -->
    <div class="map-view" id="viewDiv"></div>

    <div class="container">
      <div id="tableDiv"></div>
    </div>
  </v-main>
</template>
<script>
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";

import ArcGISMap from "@arcgis/core/WebMap";
import MapView from "@arcgis/core/views/MapView";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";
import FeatureTable from "@arcgis/core/widgets/FeatureTable.js";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer.js";
import Graphic from "@arcgis/core/Graphic.js";

import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js";

// const close = () => {
//   myBottomSheet.value.close();
// }

export default {
  name: "WebMap",
  map: null,
  view: null,
  spaceNumText: "",
  featureLayerBldgs: "",
  featureLayerClassRmInfo: "",
  roomGLayer: "",
  buildingGLayer: "", 
  levelGLayer: "",
  roomkey: "",
  props: {
    msg: String,
  },
  components: {},
  mounted() {
    this.map = new ArcGISMap({
      portalItem: {
        id: this.msg,
      },
    });

    this.view = new MapView({
      map: this.map,
      // container: this.$el,
      container: "viewDiv",
      popup: {
        autoOpenEnabled: false,
      }, // Disable popups
    });

    this.SET_VIEW(this.view)

    this.view.when(() => {
      console.log("view ready..!");
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        //deviceType = "mobile";
        this.SET_IS_MOB(true);
      }
      this.loadRooms(21);
      // load Rooms

      // Add Graphics Layer
      this.roomGLayer = new GraphicsLayer({id:'roomGLayer'});
      this.levelGLayer = new GraphicsLayer({id:'levelGLayer'});
      this.buildingGLayer = new GraphicsLayer({id:'buildingGLayer'});

      this.featureLayerBldgs = new FeatureLayer({
        url: "https://services.maps.arizona.edu/pdc/rest/services/CTSMap/MapServer/2",
        // title: "US Colleges and Universities"
      });
      // map.addMany([roomGLayer,buildingGLayer,levelGLayer,featureLayerBldgs])
      this.map.addMany([this.roomGLayer, this.buildingGLayer, this.levelGLayer]);

      this.featureLayerClassRmInfo = new FeatureLayer({
        url: "https://services.maps.arizona.edu/pdc/rest/services/CTSMap/MapServer/1",
        // title: "US Colleges and Universities"
      });

      // Create the FeatureTable from the provided FeatureLayer
      const featureTable = new FeatureTable({
        view: this.view,
        layer: this.featureLayerClassRmInfo,
        multiSortEnabled: true,
        // visibleElements: { selectionColumn: false },
        // highlightIds,
        tableTemplate: {
          // Autocast to TableTemplate
          columnTemplates: [
            // Takes an array of FieldColumnTemplate and GroupColumnTemplate
            {
              // Autocast to FieldColumnTemplate.
              type: "field",
              fieldName: "RoomID",
              label: "Room",
              direction: "asc",
            },
            {
              type: "field",
              fieldName: "Building",
              label: "Building",
            },
            {
              type: "field",
              fieldName: "Classification",
              label: "Classification",
            },
            {
              type: "field",
              fieldName: "Configuration",
              label: "Configuration",
            },
          ],
        },
        container: document.getElementById("tableDiv"),
      });

      // or removed from the feature table's selection
      featureTable.on("selection-change", (event) => {
        // featureTable.highlightIds.removeAll();
        let addedRows = event.added; // An array of features added to the selection
        let removedRows = event.removed; // An array of features removed from the selection
        // console.log("addedRows::",addedRows," removeRows::",removedRows)
      });

      let features = [];
      // Listen for changes in the collection of highlighted features
      // Listen for the table's selection-change event
      featureTable.on("selection-change", (changes) => {
        // if the feature is unselected then remove the objectId
        // of the removed feature from the features array
        // featureTable.highlightIds.removeAll();
        changes.removed.forEach((item) => {
          // console.log("item::", item)
          const data = features.find((data) => {
            return data === item.objectId;
          });
          if (data) {
            features.splice(features.indexOf(data), 1);
          }
        });
        
        // If the selection is added, push all added selections to array
        changes.added.forEach((item) => {
          // console.log("item::", item, item.feature.attributes.Join_Key)//, " Test::", feature.attributes.Join_Key) //[0].feature.attributes.Join_Key
          // features.push(item.objectId);
          // let objId = item.objectId
          let objId = item.feature.attributes.OBJECTID;
          this.spaceNumText = item.feature.attributes.SpaceNumText;
          this.roomkey = item.feature.attributes.Join_Key
          // let feature = item.feature.attributes.
          // console.log(objId, feature)
          // console.log("spaceNumText:: ", this.spaceNumText);
          // console.log(objId);
          features.push(objId);
        });

        let i = 0;
        while (features.length > 1) {          
          featureTable.highlightIds.remove(features[i]);
          features.shift();
          i++;
          console.log("features::>", features + ","+ this.spaceNumText);
          this.highlighFeatures(features[0])
        }
        
        console.log("after while")



        
      });

      // Listen for when the view is stationary.
      // If true, set the table to display only the attributes
      // for the features falling within this extent.

      /*
      reactiveUtils.when(
        () => view.stationary,
        () => {
          // Filter out and show only the visible features in the feature table.
          featureTable.filterGeometry = view.extent;
        },
        {
          initial: true,
        }
      );
      */
    });
  },
  computed: {
    ...mapState(["View"]),
    ...mapGetters({ getView: "getView" })
  },
  methods: {

    highlighFeatures(){

      let roomGLayer =  this.map.layers.find(e=>e.id == "roomGLayer");
      let buildingGLayer =  this.map.layers.find(e=> e.id == "buildingGLayer");
      console.log("buildingGLayer:: ",buildingGLayer)
      // this.map.layers.find(e=>{ console.log(e.id);});
              //   console.log(e.title,"--",e.id);
              // })

      // Select Building on the map
      let query = this.featureLayerBldgs.createQuery();
        // query.where = "OBJECTID = "+features[0]
        query.where = "SpaceNumText = '" + this.spaceNumText + "'";
        // query.outFields = "*"
        let _this = this;
        this.featureLayerBldgs.queryFeatures(query).then(function (response) {
          if (response.features.length > 0) {
            console.log("response::", response.features);
            // building = response.features

            // Add Buildings on the map
            let graphicA = new Graphic({
              // graphic with line geometry
              geometry: response.features[0].geometry, // set geometry here
              symbol: {
                type: "simple-fill",
                outline: { width: 2, color: [0, 0, 0] },
                color: [255, 255, 255, 0.15],
              }, // set symbol here
            });

            buildingGLayer.removeAll();
            roomGLayer.removeAll();
            buildingGLayer.graphics.add(graphicA);
            var opts = { duration: 1000, // Duration of animation will be 5 seconds
            };
            console.log("Target:: ",response.features[0].geometry, "-- ", _this.view)
            _this.view.goTo(
              {
                target: response.features[0].geometry,
                // zoom: 19
              },
              opts
            );
          }
        });

        
        // Select Room on the map
        let symbol = {
                    type: "simple-fill",
                    outline: { color: [119, 119, 119, 3] },
                    color: [255, 255, 255, 0.8]
                };

        this.featureLayerRms = new FeatureLayer({
          url: "https://services.maps.arizona.edu/pdc/rest/services/Interior/MapServer/16",
          // title: "US Colleges and Universities"
        });

        
        let queryRm = this.featureLayerRms.createQuery();
        // query.where = "OBJECTID = "+features[0]
        queryRm.where =
          "ROOMEXT.BldgAlpha = '" + this.spaceNumText + "' AND ROOMEXT.fl_id = '1'";
        // query.outFields = "*"
        this.featureLayerRms.queryFeatures(queryRm).then(function (response) {
          if (response.features.length > 0) {
            console.log("Rooms response::", response.features);
            // this.roomkey
            // Find the highlighted feature below and add it on the map later
            // response.features.attributes.find(a=>Level_1.Join_Key == this.roomkey)
            let rms = []
            response.features.forEach(g=>{
              let rmGraphic = new Graphic({
                // graphic with line geometry
                geometry:g.geometry,
                symbol: symbol
              })
              rms.push(rmGraphic)
            })
            // console.log("Rooms response::", rms);
            _this.roomGLayer.graphics.addMany(rms);
            // building = response.features

            // // Add Buildings on the map
            // let graphicA = new Graphic({
            //   // graphic with line geometry
            //   geometry: response.features[0].geometry, // set geometry here
            //   symbol: {
            //     type: "simple-fill",
            //     outline: { width: 2, color: [0, 0, 0] },
            //     color: [255, 255, 255, 0.15],
            //   }, // set symbol here
            // });

            // // Add Buildings on the map
            // let graphicA = new Graphic({

            // buildingGLayer.removeAll();
            // buildingGLayer.graphics.add(graphicA);            
            
          }
        }); 
    },

    ...mapMutations(["SET_IS_MOB","SET_VIEW"]),
    ...mapActions(["loadRooms"]),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://js.arcgis.com/4.28/esri/themes/light/main.css");
.map-view {
  /* padding-top: 48px; */
  /* height: 93%; */
  height: 70%;
  width: 100%;
}

.container {
  height: 30%;
  width: 100%;
}
/** Remove black focus boundary around map */
.esri-view {
  /* .esri-view-surface--inset-outline:focus::after { */
  --esri-view-outline-color: none !important;
  --esri-view-outline: none !important;
}
</style>
